import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCalendarAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import renderUtils from '../../../helpers/renderUtils';
import dateUtils from '../../../helpers/dateUtils';

const DateRangeDisplay = ({
                            startDate,
                            endDate,
                            onClear,
                            onToggle,
                            isOpen,
                            showNight = false, // 👈 default to false
                            fromLabel,
                            toLabel
                          }) => {
  const nightCount = dateUtils.getNightCount(startDate, endDate);

  return (
    <div
      className={`w-100 datepicker-input ${isOpen ? 'datepicker-input-active' : ''}`}
      onClick={onToggle}
    >
      <FontAwesomeIcon icon={faCalendarAlt} className="icon" />
      <span className={"text-muted"}>
        {startDate && endDate ? (
          <>
            {renderUtils.formatDate(startDate)} - {renderUtils.formatDate(endDate)}
            {showNight && (
              <> ({nightCount}\u00A0{renderUtils.getNightLabel(nightCount)})</>
            )}
          </>
        ) : (
          `${fromLabel || 'Przyjazd'} - ${toLabel || 'Wyjazd'}`
        )}
      </span>

      {(startDate || endDate) && (
        <FontAwesomeIcon
          icon={faTimes}
          className="icon clear-icon"
          onClick={(e) => {
            e.stopPropagation();
            onClear();
          }}
        />
      )}
    </div>
  );
};

export default DateRangeDisplay;
